import { AccordionIcon as ChakraAccordionIcon } from '@chakra-ui/react';

type AccordionIconProps = React.ComponentProps<typeof ChakraAccordionIcon>;

const AccordionIcon = ({ ...props }: Readonly<AccordionIconProps>) => {
  return <ChakraAccordionIcon {...props} />;
};

export default AccordionIcon;
